import React from 'react';

export default function UserCommunicationSystemPage() {
    return <div>UserCommunicationSystemPage</div>;
}
